import 'antd/es/dropdown/style';
import _Dropdown from 'antd/es/dropdown';
import 'antd/es/avatar/style';
import _Avatar from 'antd/es/avatar';
import _extends from 'babel-runtime/helpers/extends';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import 'antd/es/menu/style';
import _Menu from 'antd/es/menu';

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useEffect, useState } from 'react';
import { UserOutlined } from '@ant-design/icons';

import cx from 'classnames';
import { getToken, getCompanyId, getInformOutLines, searchNotice, readedNotice, removeToken, clearToken } from 'jcb-token-kit';
import { dyDomainNy, wjDomainNy, pxDomainNy, jcbDomainNy, homeNy } from '../utils/constant';
import NavMsg from './NavMsg';
import nyTitle from '../assets/ny_title.png';
import logoutImg from '../assets/logout.png';
import defaultAvatar from '../assets/user-small.png';
import './NyHeader.css';

var SubMenu = _Menu.SubMenu;

var SYS_MENU = [{ id: 'home', name: '首页' }, { id: 'jcb', name: '实地测评系统' }, { id: 'survey', name: '群众评价系统' }, { id: 'data', name: '数据展示平台' }, {
  id: 'pxb',
  name: '调研培训平台',
  children: [{ id: 'study', name: '学习中心' }, { id: 'pxbmanage', name: '管理后台' }]
}, { id: 'manage', name: '账号管理' }];
var searchInitData = {
  informType: 'SYSTEM_INFORM',
  status: 'NOT_READ',
  serviceType: null,
  page: 0,
  size: 5
};
var navStyles = {
  background: '#07c160',
  boxShadow: '0px 4px 8px 0px rgba(7,193,96,0.12)'
};
var NyHeader = function NyHeader(_ref) {
  var _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === undefined ? 1000 : _ref$minWidth,
      _ref$onLogout = _ref.onLogout,
      onLogout = _ref$onLogout === undefined ? function () {} : _ref$onLogout,
      _ref$avatar = _ref.avatar,
      avatar = _ref$avatar === undefined ? '' : _ref$avatar,
      userName = _ref.userName,
      ispxb = _ref.ispxb;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      noticNum = _useState2[0],
      setNoticNum = _useState2[1];

  var handleClick = function handleClick(e) {
    console.log(e);
    if (e.id === 'home') {
      window.location.href = dyDomainNy + '/user/home?companyid=' + (getCompanyId() || 0) + '&token=' + getToken();
    }
    if (e.id === 'survey') {
      window.location.href = wjDomainNy + '?companyid=' + (getCompanyId() || 0) + '&token=' + getToken();
    }
    if (e.id === 'manage') {
      window.location.href = dyDomainNy + '/user/staff/list?companyid=' + (getCompanyId() || 0) + '&token=' + getToken();
    }
    if (e.id === 'jcb' && ispxb) {
      window.location.href = jcbDomainNy + '/dashboard?companyid=' + (getCompanyId() || 0) + '&token=' + getToken();
    }
    if (e.id === 'pxb') {
      window.location.href = pxDomainNy + '/?role=learner&companyid=' + (getCompanyId() || 0) + '&token=' + getToken();
    }
    if (e.id === 'study') {
      window.location.href = pxDomainNy + '/user/staff/list?companyid=' + (getCompanyId() || 0) + '&token=' + getToken();
    }
    if (e.id === 'pxbmanage') {
      window.location.href = pxDomainNy + '/learner/mycourse?companyid=' + (getCompanyId() || 0) + '&token=' + getToken();
    }
    if (e.id === 'data') {
      window.location.href = jcbDomainNy + '/projects/1256/nybi/summary?year=2019&token=' + getToken();
    }
  };
  var getSelectPath = function getSelectPath(menus) {};
  var updateSelectKey = function updateSelectKey(menu) {
    // const selectedKey = getSelectPath(menu);
    // if (selectedKey) {
    //   setSelectKey(selectedKey);
    // }
  };
  var getNotice = function getNotice() {
    getInformOutLines().then(function (_ref2) {
      var allCount = _ref2.allCount;

      setNoticNum(allCount);
    });
  };
  useEffect(function () {
    getNotice();
  }, []);

  var onLogoutHandler = function onLogoutHandler() {
    if (process.env.REACT_APP_TYPE === 'ny') {
      window.location.href = homeNy;
      removeToken();
      sessionStorage.clear();
      clearToken();
    } else if (onLogout) {
      onLogout();
    }
  };
  var renderName = function renderName() {
    if (userName && userName.length > 2) {
      return userName.substring(userName.length - 2, userName.length);
    }
    return userName || '';
  };
  var isActiveMenu = function isActiveMenu(id) {
    if (ispxb) {
      return id === 'pxb' ? 'ny-menu-item-active' : 'ny-menu-item';
    }
    return id === 'jcb' ? 'ny-menu-item-active' : 'ny-menu-item';
  };

  return React.createElement(
    'div',
    { className: 'custom-menu--ny-menu' },
    React.createElement(
      'div',
      {
        style: _extends({
          minWidth: minWidth + 'px',
          left: 0
        }, navStyles),
        className: cx({
          'navbar-container--ny-menu': true,
          'fixed-nav': true
        })
      },
      React.createElement(
        'div',
        { className: 'left-box' },
        React.createElement(
          'div',
          { className: 'left-menu' },
          React.createElement('img', { className: 'logo', src: nyTitle, height: '36', width: '477' })
        ),
        ispxb ? React.createElement(
          'div',
          { className: 'ny-menu' },
          React.createElement(
            _Menu,
            {
              selectedKeys: ['pxb'],
              className: 'navbar-menu'
              // onClick={handleClick}
              , mode: 'horizontal'
            },
            SYS_MENU.map(function (item) {
              return item.children && item.children.length > 0 ? React.createElement(
                SubMenu,
                {
                  title: React.createElement(
                    'span',
                    { style: { marginRight: '28px' } },
                    item.name
                  )
                },
                item.children.map(function (v) {
                  return React.createElement(
                    _Menu.Item,
                    {
                      key: item.id,
                      style: { marginRight: '40px' },
                      onClick: function onClick() {
                        handleClick(v);
                      }
                    },
                    v.name
                  );
                })
              ) : React.createElement(
                _Menu.Item,
                {
                  key: item.id,
                  style: { marginRight: '40px' },
                  onClick: function onClick() {
                    handleClick(item);
                  }
                },
                item.name
              );
            })
          )
        ) : React.createElement(
          'div',
          { className: 'ny-menu' },
          SYS_MENU.map(function (item) {
            return React.createElement(
              'div',
              {
                className: isActiveMenu(item.id),
                key: item.id,
                onClick: function onClick() {
                  handleClick(item);
                }
              },
              item.name
            );
          })
        )
      ),
      React.createElement(
        'div',
        { className: 'right-menu' },
        React.createElement(
          'div',
          {
            className: 'return-btn-con download-btn-con',
            style: { marginRight: '10px' }
          },
          React.createElement(NavMsg, {
            ny: true,
            token: getToken(),
            searchInitData: searchInitData,
            companyid: getCompanyId() || 0,
            noticNum: noticNum,
            getNotice: getNotice,
            getInformOutLines: getInformOutLines,
            searchNotice: searchNotice,
            readedNotice: readedNotice
          })
        ),
        React.createElement(
          _Dropdown,
          {
            overlayClassName: 'dropdown--jcb-menu',
            overlay: React.createElement(
              _Menu,
              {
                style: {
                  width: '120px',
                  height: '54px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '10px 0'
                }
              },
              React.createElement(
                _Menu.Item,
                { key: 'logout', onClick: onLogoutHandler },
                React.createElement(
                  'div',
                  { className: 'logout-area' },
                  React.createElement('img', {
                    style: { marginRight: '7px' },
                    src: logoutImg,
                    height: '15'
                  }),
                  '\u9000\u51FA\u767B\u5F55'
                )
              )
            )
          },
          React.createElement(
            'div',
            { style: { cursor: 'pointer' } },
            avatar ? React.createElement(_Avatar, {
              icon: React.createElement(UserOutlined, null),
              style: { marginRight: '8px' },
              src: avatar
            }) : React.createElement(
              'div',
              { className: 'photo-box-ny' },
              renderName()
            )
          )
        ),
        userName && React.createElement(
          'span',
          { className: 'user' },
          userName
        )
      )
    ),
    React.createElement('div', { style: { minWidth: minWidth + 'px' }, className: 'shadow' })
  );
};

__signature__(NyHeader, 'useState{[noticNum, setNoticNum](0)}\nuseEffect{}');

var _default = NyHeader;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SubMenu, 'SubMenu', 'src/components/NyHeader.js');
  reactHotLoader.register(SYS_MENU, 'SYS_MENU', 'src/components/NyHeader.js');
  reactHotLoader.register(searchInitData, 'searchInitData', 'src/components/NyHeader.js');
  reactHotLoader.register(navStyles, 'navStyles', 'src/components/NyHeader.js');
  reactHotLoader.register(NyHeader, 'NyHeader', 'src/components/NyHeader.js');
  reactHotLoader.register(_default, 'default', 'src/components/NyHeader.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();